import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import Cookies from "js-cookie";

const API = () => {
  const errorLink = onError(({ networkError }) => {
    if (networkError && networkError.statusCode) console.error(`ERRORE ${networkError.statusCode}`);
  });
  const httpLink = createHttpLink({
    credentials: "include",
    uri: process.env.REACT_APP_APOLLO_URI,
  });

  const authLink = setContext((_, { headers }) => {
    const token = Cookies.get("jwt");
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        ...(token && { authorization: `Bearer ${token}` }),
      },
    };
  });

  return new ApolloClient({
    credentials: "include",
    link: errorLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
  });
};

export default API;
